var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlossom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 10.8799L62.275 12.0449C71.0788 16.5512 78.6378 23.1556 84.285 31.2749C88.9913 29.0394 93.9704 27.4307 99.095 26.4899L105 25.3999V65.4999C105 77.4346 100.259 88.8805 91.8198 97.3197C83.3807 105.759 71.9347 110.5 60 110.5C48.0653 110.5 36.6193 105.759 28.1802 97.3197C19.7411 88.8805 15 77.4346 15 65.4999V25.3999L20.9 26.4899C26.0263 27.4303 31.0071 29.039 35.715 31.2749C41.3622 23.1556 48.9212 16.5512 57.725 12.0449L60 10.8799ZM44.39 36.3249C50.545 40.6387 55.8393 46.0653 60 52.3249C64.1612 46.0657 69.4554 40.6393 75.61 36.3249C71.4634 30.5623 66.1433 25.7432 60 22.1849C53.8568 25.7433 48.5367 30.5624 44.39 36.3249ZM54.495 62.6699C50.0834 54.1008 43.3005 46.9812 34.955 42.1599C31.8067 40.3418 28.4684 38.8747 25 37.7849V65.4999C25 81.9499 36.35 95.7499 51.645 99.4999C50.5499 94.9138 49.9978 90.2149 50 85.4999C50 77.4149 51.595 69.7049 54.495 62.6699ZM62.27 100.425C71.1407 99.8483 79.4596 95.918 85.5382 89.4318C91.6169 82.9455 94.9997 74.3893 95 65.4999V37.7849C84.8456 40.975 75.9748 47.3235 69.6795 55.9059C63.3841 64.4882 59.993 74.8562 60 85.4999C60 90.7049 60.795 95.7199 62.265 100.425",
    fill: "#288344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlossom);
export default __webpack_public_path__ + "static/media/blossom.0812fea26c0681fe71beda3138aa9433.svg";
export { ForwardRef as ReactComponent };